var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C10 2.34315 11.3431 1 13 1C14.6569 1 16 2.34315 16 4V5H19C20.1046 5 21 5.89543 21 7V10C21 11.1046 20.1046 12 19 12H18C17.4477 12 17 12.4477 17 13C17 13.5523 17.4477 14 18 14H19C20.1046 14 21 14.8954 21 16V19C21 20.1046 20.1046 21 19 21H16C14.8954 21 14 20.1046 14 19V18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18V19C12 20.1046 11.1046 21 10 21H7C5.89543 21 5 20.1046 5 19V16H4C2.34315 16 1 14.6569 1 13C1 11.3431 2.34315 10 4 10H5V7C5 5.89543 5.89543 5 7 5H10V4ZM13 3C12.4477 3 12 3.44772 12 4V5C12 6.10457 11.1046 7 10 7L7 7V10C7 11.1046 6.10457 12 5 12H4C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H5C6.10457 14 7 14.8954 7 16V19H10V18C10 16.3431 11.3431 15 13 15C14.6569 15 16 16.3431 16 18V19H19V16H18C16.3431 16 15 14.6569 15 13C15 11.3431 16.3431 10 18 10H19V7H16C14.8954 7 14 6.10457 14 5V4C14 3.44772 13.5523 3 13 3Z",
    fill: "#0A0046",
    stroke: "#DFE2E9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsicon);
export default __webpack_public_path__ + "static/media/Operations icon.4630e5f94966fc0b8ee8ac7aff4d95b6.svg";
export { ForwardRef as ReactComponent };